import { Fragment, createElement, useState } from 'react';
import { Card } from 'antd';
import { ArrayBase } from '@formily/antd';
import { observer, VoidField } from '@formily/react';
import { uuid } from '../../shared';
import cls from 'classnames';
const DroppableWidget = () => createElement("div", { className: "lc-container-placeholder" }, "\u62D6\u62FD\u7EC4\u4EF6\u6216\u6A21\u677F\u5230\u8FD9\u91CC");
export const ArrayCardsPreview = observer((props) => {
    const fieldItemProperties = Object.values(props.fieldProps?.items?.properties || {});
    const hasRemove = fieldItemProperties.some((item) => item['x-component'] === 'ArrayCards.Remove');
    const hasIndex = fieldItemProperties.some((item) => item['x-component'] === 'ArrayCards.Index');
    const hasMoveDown = fieldItemProperties.some((item) => item['x-component'] === 'ArrayCards.MoveDown');
    const hasMoveUp = fieldItemProperties.some((item) => item['x-component'] === 'ArrayCards.MoveUp');
    const fieldProperties = Object.values(props.fieldProps?.properties || {});
    const hasAddition = fieldProperties.some((item) => item['x-component'] === 'ArrayCards.Addition');
    const componentProps = props.componentProps?.['x-component-props'] || {};
    const renderCard = () => {
        const children = props.children;
        return (createElement(ArrayBase, { disabled: true },
            createElement(ArrayBase.Item, { index: 0, record: null },
                createElement(Card, Object.assign({}, componentProps, { title: createElement(Fragment, null,
                        hasIndex && createElement(ArrayBase.Index, null),
                        createElement("span", { "data-content-editable": "x-component-props.title" }, componentProps.title)), className: cls('ant-formily-array-cards-item', componentProps.className), extra: createElement(Fragment, null,
                        hasRemove && createElement(ArrayBase.Remove, null),
                        hasMoveDown && createElement(ArrayBase.MoveDown, null),
                        hasMoveUp && createElement(ArrayBase.MoveUp, null),
                        componentProps.extra) }),
                    createElement("div", null, children?.length ? children.map((node) => node) : createElement(DroppableWidget, null)))),
            hasAddition && createElement(ArrayBase.Addition, { title: "Addition" })));
    };
    return createElement("div", null, renderCard());
});
ArrayBase.mixin(ArrayCardsPreview);
export default (props) => {
    const [defaultName] = useState(uuid());
    return (createElement(VoidField, { name: props.fieldProps.name || defaultName, pattern: "editable" },
        createElement(ArrayCardsPreview, Object.assign({}, props), props.children)));
};
